import React, { useState } from 'react';
import { connect } from 'react-redux';
import Button from '@mui/material/Button';

import { Cell, Column, Table } from 'fixed-data-table-2';
import SortableHeaderCell from '../../components/SortableHeaderCell/SortableHeaderCell';
import TableMixin from '../../components/TableMixin/TableMixin';
import TextCell from '../../components/TextCell/TextCell';
import CPressureSensorsSettings from '../../containers/CPressureSensorsSettings/CPressureSensorsSettings';
import CTableActions from '../../containers/CTableActions/CTableActions';
import { DateType } from '../../containers/UIhelper/UIDateFormater';
import MultiDayTrendDialog from '../SensorsTabs/Pressure/MultiDayTrendDialog';
import * as actionsPressure from '../../actions/SensorsPressureActions';

const PRESSURE_CONVERSION = {
  meter: { factor: 1, label: 'Meter' },
  bar: { factor: 0.0980665, label: 'Bar' },
  kpa: { factor: 9.80665, label: 'kPa' },
  psi: { factor: 1.42233, label: 'PSI' },
};

const PressureSensorsTable = (props) => {
  const [multiDayOpen, setMultiDayOpen] = useState(false);

  const { items, indexMap, selectedFeature, pHeight, pWidth, sortProp, localSortProp, rowClickEvent, rowClassNameGetter, goToRow, user, t, pressureUnit,
          projectId, lastPressureSample, timeZone, projectTimezone, fetchMultiDayReading, fetchMultiDayTransients, fetchPressureAlarmsForSensor,
          fetchTransientReading, transientThresholds } = props;
  const conversion = PRESSURE_CONVERSION[pressureUnit] || PRESSURE_CONVERSION.meter;
  const selectedSensorExists = !!selectedFeature && items.some((it) => String(it.ID) === String(selectedFeature));
  const trendData = items.map((item) => ({
    last_trend_avg_m: item.last_trend_avg_m != null ? (parseFloat(item.last_trend_avg_m) * conversion.factor).toFixed(2) : item.last_trend_avg_m,
    last_trend_max_m: item.last_trend_max_m != null ? (parseFloat(item.last_trend_max_m) * conversion.factor).toFixed(2) : item.last_trend_max_m,
    last_trend_min_m: item.last_trend_min_m != null ? (parseFloat(item.last_trend_min_m) * conversion.factor).toFixed(2) : item.last_trend_min_m,
  }));

  return (
    <div>
      <Table
        maxHeight={pHeight - 93}
        width={pWidth}
        rowsCount={items.length}
        rowHeight={30}
        headerHeight={30}
        onRowClick={rowClickEvent}
        rowClassNameGetter={rowClassNameGetter}
        scrollToRow={goToRow}
        {...props}
      >
        <Column
          columnKey="ID"
          width={60}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="ID" />} />
        {/* <Column
          columnKey="logger_uid"
          width={130}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="logger_uid" />} /> */}
        <Column
          columnKey="aqs_logger_id"
          width={150}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="aqs_logger_id" />} />
        <Column
          columnKey="logger_type_name"
          width={90}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="logger_type_name" />} />
        {/* <Column
          columnKey="sensor_installation_date"
          width={140}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="sensor_installation_date" dateType={DateType.DATE_AND_TIME} />} /> */}
        <Column
          columnKey="last_trend_avg_m"
          width={60}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} title={t('avg')} />}
          cell={<TextCell data={trendData} field="last_trend_avg_m" />} />
        <Column
          columnKey="last_trend_max_m"
          width={60}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} title={t('max')} />}
          cell={<TextCell data={trendData} field="last_trend_max_m" />} />
        <Column
          columnKey="last_trend_min_m"
          width={60}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} title={t('min')} />}
          cell={<TextCell data={trendData} field="last_trend_min_m" />} />
        <Column
          columnKey="logger_last_active_time"
          width={140}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="logger_last_active_time" dateType={DateType.DATE_AND_TIME} />} />
        <Column
          columnKey="logger_last_install_date"
          width={140}
          flexGrow={1}
          header={<SortableHeaderCell sortTable={sortProp} />}
          cell={<TextCell data={items} field="logger_last_install_date" dateType={DateType.DATE_AND_TIME} />} />
      </Table>

      {items && items.length > 0 && (
        <>
          <CTableActions type="sensors" notify={props.notify} />
          <div style={{ float: 'right', textAlign: 'right' }}>
            <div style={{ padding: '2px 8px' }}>
              {t('selected_selectedindex_total_total', { selectedIndex: (indexMap[selectedFeature] + 1) || 0, total: items.length })}
            </div>
            <div style={{ padding: '4px 8px' }}>
              <Button
                variant="contained"
                color="primary"
                size="small"
                disabled={!selectedSensorExists}
                onClick={() => setMultiDayOpen(true)}
              >
                {t('multi_day_trend')}
              </Button>
            </div>
          </div>
        </>
      )}

      <MultiDayTrendDialog
        open={multiDayOpen}
        onClose={() => setMultiDayOpen(false)}
        projectId={projectId}
        sensorId={selectedFeature}
        lastPressureSample={lastPressureSample}
        timeZone={timeZone}
        projectTimezone={projectTimezone}
        fetchMultiDayReading={fetchMultiDayReading}
        fetchMultiDayTransients={fetchMultiDayTransients}
        fetchPressureAlarmsForSensor={fetchPressureAlarmsForSensor}
        fetchTransientReading={fetchTransientReading}
        transientThresholds={transientThresholds}
        pressureUnit={pressureUnit}
        pressureSensors={items}
      />
    </div>
  );
}


const pressureSensorsTable = TableMixin(PressureSensorsTable, CPressureSensorsSettings);

const mapStateToProps = (state) => {
  const selectedProject = state.leaksList.selectedProject;
  const projectData = state.leaksList.leaksByProject[selectedProject];
  return {
    pressureUnit: state.local.pressureUnit || 'meter',
    projectId: selectedProject,
    lastPressureSample: projectData?.sensors?.pressureSensors?.samples?.[0],
    timeZone: state.local.timeZone,
    projectTimezone: projectData?.projectDetails?.time_zone,
    transientThresholds: state.leaksList.pressure?.transientThresholds || { med: 20, high: 30 },
  };
};

const mapDispatchToProps = (dispatch) => ({
  fetchMultiDayReading: (projectId, loggerId, startDate, endDate) =>
    dispatch(actionsPressure.fetchMultiDayReading(projectId, loggerId, startDate, endDate)),
  fetchMultiDayTransients: (projectId, loggerId, startDate, endDate) =>
    dispatch(actionsPressure.fetchMultiDayTransients(projectId, loggerId, startDate, endDate)),
  fetchPressureAlarmsForSensor: (projectId, loggerId) =>
    dispatch(actionsPressure.fetchPressureAlarmsForSensor(projectId, loggerId)),
  fetchTransientReading: (projectId, sensorId, readingId) =>
    dispatch(actionsPressure.fetchPressureTransientReading(projectId, sensorId, readingId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(pressureSensorsTable);
